<template>
  <v-content class="grey lighten-3">
    <v-alert
     :value="alert"
      type="error"
      dismissible
      transition="scale-transition"
    > {{errorMsg}}
    </v-alert>
    <div id="core-view">
      <v-fade-transition mode="out-in">
        <router-view />
      </v-fade-transition>
    </div>
    <div id="viewfooter"></div>
  </v-content>
</template>

<script>
    import {
        mapState
    } from 'vuex'

  export default {
    name: 'CoreView',
    metaInfo () {
      return {
        title: 'OBARA - Operational Barrier Analysis'
      }
    },
      data: function () {
          return {
        alert: false
          }
    },
      computed: {
          ...mapState(['errorMsg'])
          /**,
        alert: {
                get () {
                    return this.$store.state.errorMsg!=''
                },
                set (v) {
                    alert(v)
                    if (!v) { this.$store.commit('errorMsg','') }
                }
        }**/
    },
      watch: {
        errorMsg(val) {
            if (val !=undefined && val!='')
              this.alert = true
            else
                this.alert = false
        },
       alert(val){
//            alert("new state:" + val)
        //    this.$store.commit('errorMsg','')
        }
      }/*,
      watch: {
        errorMsg:function() {
            if (this.$store.state.errorMsg!='') this.alert=true
        }
      }*/

  }
</script>

<style>
  #viewfooter {
    height:50px
  }
</style>
